<template>
  <div class="card mb-3" style="min-height: 60vh;">
    <div class="col-md-12">
      <h2 style="margin: 20px 20px 0px;">Full Sync Manual Export</h2>
    </div>

    <a-spin :spinning="downloadSpin">
      <div class="col-md-12" style="padding: 30px; height: 64vh;">
        <a-steps :current="currentTab" @change="onChangeTab">
          <a-step title="Step 1" description="Select profiles to extract" />
          <a-step title="Step 2" description="Configure extraction details" />
          <a-step title="Step 3" description="Review Configuration & Download" />
        </a-steps>

        <div class="col-md-12" v-if="currentTab == 0">
          <br>
          <base-input label="Profile Selection">
              <br>

              <label>
                Upload Mode:
                <a-select
                  v-model="uploadMode"
                  style="width: 120px">
                  <a-select-option value="0">
                    Local
                  </a-select-option>
                  <a-select-option value="1">
                    S3
                  </a-select-option>
                </a-select>
              </label>

              <br><br>
              <a-select mode="multiple"
                        style="width: 100%"
                        placeholder=""
                        optionFilterProp="children"
                        v-model="selectedProfiles">
                <a-select-option v-for="(profile, index) in profiles"
                                 :key="index"
                                 :value="profile">{{ _.startCase(profile)}}
                </a-select-option>
              </a-select>
              <small>
                <span class="fa fa-info-circle text-blue"/> These are the profiles that will be part of the zip file to be downloaded after the configuration.
              </small>
          </base-input>
        </div>

        <div class="col-md-12" v-if="currentTab == 1">
          <br>
          <base-input v-if="false" label="Configuration">
            <br>
            <div v-if="false">
              <a-switch checked-children="Full Export"
                        un-checked-children="Full Export"
                        v-model="fullExport"/> <br>
              <small>
                <span class="fa fa-info-circle text-blue"/> If this option is enabled, full copy of the selected profiles will be exported.
              </small>
            </div>
          </base-input>

          <div class="col-md-12">
            <base-input label="Select an Account">
              <a-select showSearch
                        style="width: 100%"
                        placeholder=""
                        optionFilterProp="children"
                        v-model="selectedAccount">
                <a-select-option v-for="(account, index) in accounts"
                                 :key="index"
                                 :value="account.id">
                  {{account.account_name}}
                </a-select-option>
              </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input label="Select a Site"
                        :disabled="[null, undefined].includes(this.selectedAccount)">
              <a-select showSearch
                        style="width: 100%"
                        placeholder="Select a Site"
                        optionFilterProp="children"
                        v-model="selectedSite"
                        :disabled="[null, undefined].includes(this.selectedAccount)">
                <a-select-option v-for="(site, index) in sites"
                                 :key="index"
                                 :value="site.id">{{site.name}}
                </a-select-option>
              </a-select>
            </base-input>
          </div>

          <div class="col-md-12">
            <base-input label="Validity Date">
              <br>
              <a-range-picker v-model="profileDateRange"
                              format="MM-DD-YYYY"
                              :placeholder="['Start Date', 'End Date']"
                              style="width:70%"/>
            </base-input>
          </div>
        </div>

        <div class="col-md-12" v-if="currentTab == 2">
          <br>
          <h6 class="text-muted">Export Details</h6>
          <small>
              <div>
                <b>Export Mode:</b> Full Sync
              </div>

              <div>
                <b>Account:</b> {{selectedAccountName}} <br>
              </div>

              <div>
                <b>Site:</b> {{selectedSiteName}} <br>
              </div>

              <div>
                <b>Validity Date:</b> {{validatityDateFormat(profileDateRange[0])}} - {{validatityDateFormat(profileDateRange[1])}} <br>
              </div>

              <b>Profiles to export:</b> &nbsp;

              <template v-for="(tag, index) in selectedProfiles">
                <a-tag :key="index" color="blue">{{ tag }}</a-tag>
              </template> <br>
          </small>
      </div>
      </div>
    </a-spin>

    <div class="col-md-12" style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
      <div class="steps-action float-right">
          <a-button
            v-if="currentTab > 0"
            @click="prevStep()">
            Previous
          </a-button>

          <a-button
            v-if="currentTab < maxTab"
            type="primary"
            @click="nextStep()"
            style="margin-left: 8px">
            Next
          </a-button>

          <a-button
            v-if="currentTab == maxTab"
            type="primary"
            style="margin-left: 8px"
            @click.prevent="proceed"
          >
            Proceed
          </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import HTTPRequest from '../../controllers/httpRequest.js';
import secureStorage from '../../controllers/secureStorage.js';
import axios from "axios";
import moment from 'moment';
import { sortAlphabetical } from '../../utilities';

export default {
  data() {
    return {
      uploadMode: "0",
      maxTab: 2,
      downloadSpin: false,
      currentTab: 0,
      profileDateRange: [moment(), moment()],
      accounts: [],
      sites: [],
      profiles: [],
      selectedProfiles: [],
      selectedAccount: null,
      selectedSite: null,
      selectedAccountName: '',
      selectedSiteName: '',
    }
  },
  computed: {
    ...mapState(['endPoint'])
  },
  watch: {
    selectedAccount: function() {
      if (this.selectedAccount) {
        this.selectedAccountName = '';
        this.selectedSite = null;
        this.selectedSiteName = '';
        this.setSelectedAccountName();
        this.populateSites();
      }
    },
    selectedSite: function() {
      this.setSelectedSiteName();
    }
  },
  mounted: async function(){
    // Get all Valid and Active accounts
    let accounts = await HTTPRequest.getRequest(this.endPoint + 'accounts/get_valid_accounts', null, null)
    accounts = sortAlphabetical(accounts, 'account_name');
    this.accounts = accounts || [];

    // Get Full Sync Default Profiles
    const profileRequest = await HTTPRequest.getRequest(`${this.endPoint}systems/full_sync/default_full_sync_profiles`, null, null)
    this.profiles = profileRequest ? profileRequest.profiles : this.profiles;

    this.selectedProfiles = this.profiles;
  },
  methods: {
    validatityDateFormat(date) {
      return moment(date).format('MM-DD-YYYY');
    },
    checkErrors() {
      if (this.currentTab == 1) {
        let desc = '';
        if (!this.selectedAccount) {
          // If account field is blank
          desc = 'Please select an Account'
        } else if (!this.selectedSite) {
          // If site field is blank
          desc = 'Please select a Site'
        }

        if (desc) {
          // Prompt error if there's an error
          this.$notification['error']({
            message: 'Export Error',
            description: desc,
          });
          return true;
        }
      }

      return false;
    },
    onChangeTab(current) {
      const hasErrors = this.checkErrors();
      if (hasErrors) { return; }

      this.currentTab = current;
    },
    prevStep() {
      this.currentTab--;
    },
    nextStep() {
      const hasErrors = this.checkErrors();
      if (hasErrors) { return; }

      this.currentTab++;
    },
    setSelectedAccountName() {
      this.accounts.map( account => {
        if (account.id == this.selectedAccount) this.selectedAccountName = account.account_name
      })
    },
    setSelectedSiteName() {
      this.sites.map( site => {
        if (site.id == this.selectedSite) this.selectedSiteName = site.name
      })
    },
    async populateSites() {
      if (!this.selectedAccount) { return; }

      let sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_sites_with_terminal?account_id=${this.selectedAccount}`, null, null)
      sites = [{id:-1, name:"All Sites"}, ...sites]
      sites = sortAlphabetical(sites, 'name');
      this.sites = sites || [];
    },
    async proceed() {
      this.downloadSpin = true
      const valid_from = moment(this.profileDateRange[0]).format('YYYY-MM-DD');
      const valid_to = moment(this.profileDateRange[1]).format('YYYY-MM-DD');

      if(this.uploadMode == "1"){
        let processed_profiles = []
        for(var x = 0; x < this.selectedProfiles.length; x++){
            let profile = this.selectedProfiles[x]
            let processed_profile = _.startCase(profile).split(' ').join('');
            // console.log(processed_profile)
            processed_profiles.push(processed_profile)
        }
        // console.log(">>>>>")
        // console.log(processed_profiles)
        this.selectedProfiles = processed_profiles
      }

      const syncPayload = {
        account_id: this.selectedAccount,
        site_id: this.selectedSite,
        profiles: this.selectedProfiles,
        valid_from: valid_from,
        valid_to: valid_to,
        upload_mode: this.uploadMode
      }

      axios({
        method: 'post',
        // responseType: 'blob', // important
        url: this.endPoint + "systems/full_sync/manual_extract",
        headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
        data: syncPayload
      })
      
      // const url = window.URL.createObjectURL(new Blob([downloadFile.data], {type: 'application/zip'}));
      // const link = document.createElement('a');
      // link.href = url;
      // const site = this.sites.filter( x => x.id == this.selectedSite)[0];
      // let site_code = site ? site.refcode || site.code : ''
      // const extraction_date = moment().format('YYYY_MM_DD');

      // link.setAttribute('download', `${site_code}_full_sync_profiles_${extraction_date}.zip`);
      // document.body.appendChild(link);

      // link.click();
      // window.URL.revokeObjectURL(url);

      this.$notification['success']({
        message: 'Successful Operation',
        description: "Export has been added to Job Monitoring. Check the ongoing jobs for status update.",
      });

      this.downloadSpin = false
      this.currentTab = 0
      this.selectedSite = null
      this.selectedSiteName = null
      this.setSelectedSiteName();
      this.selectedProfiles = this.profiles
      this.lastUpdateDate = moment()
    },
  }
}
</script>

<style scoped>
</style>
